import { render, staticRenderFns } from "./culbDynamic.vue?vue&type=template&id=d9f9655c&scoped=true&"
import script from "./culbDynamic.vue?vue&type=script&lang=js&"
export * from "./culbDynamic.vue?vue&type=script&lang=js&"
import style0 from "./culbDynamic.vue?vue&type=style&index=0&id=d9f9655c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f9655c",
  null
  
)

export default component.exports